import { CardImage, Pricing } from '.';
import { MouseEvent } from 'react';
import classNames from 'classnames';
import { AvailableToPurchaseFlag, CartItemChangeType } from '@/types/api';
import { IconUser } from '@/features/icons';
import { BasketCardVariants } from './basket-card-variants';
import { BasketCardProps } from './types';
import { AddToCartCounter } from './add-to-cart/index';
import { AppNextLink } from '../app-next-link';
import { IconGift } from '../icons';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { getProductURL } from '../navigation/utils/url-helpers';
import { handleShowPageLoading } from '../page-loading/utils/show-loading';
import { CartActionPlacement } from '../webengage/types';
export const BasketCard = ({
  pricingProps,
  brand,
  name,
  slug,
  image,
  isLazy,
  atpId,
  maxLimited,
  initialCount,
  color,
  isGift = false,
  changeType,
  flags,
  shipBySeller,
  weightUnit,
  weightValue
}: BasketCardProps) => {
  const isPromotionExcluded = flags?.includes(AvailableToPurchaseFlag.PromotionExcluded);
  const {
    isMobile
  } = useMobileDetect();
  const handleClick = (event: MouseEvent) => {
    if (!event.ctrlKey) handleShowPageLoading();
  };
  if (!initialCount) return null;
  const imageSize = isMobile ? 88 : 120;
  return <AppNextLink prefetch={false} href={getProductURL(slug || '')} className={classNames('flex w-full flex-col gap-2 rounded border border-border-gray-light bg-surface-solid-0 p-2 shadow-sm lg:gap-1 lg:px-3 lg:py-2', {
    'opacity-60': changeType === CartItemChangeType.OutOfStock
  })} onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="BasketCard" data-sentry-source-file="basket-card.tsx">
            <div className='flex gap-3 lg:gap-2'>
                {isGift && <div id={atpId} className='relative flex h-30 rounded bg-primary-main px-4 text-text-white lg:h-[124px]'>
                        <span className='absolute right-1/2 top-1/2 flex -translate-y-1/2 translate-x-1/2 rotate-90 items-center gap-1 whitespace-nowrap font-medium'>
                            <IconGift className='h-4 w-4 lg:h-5 lg:w-5' />
                            <span className='text-caption-12 font-medium lg:text-body-14'>هدیه خرید!</span>
                        </span>
                    </div>}

                <CardImage alt={name} image={image} srcSet={{
        desktop: 130,
        mobile: 175
      }} isLazy={isLazy} imageClassName='h-auto w-[92px] aspect-square lg:w-30 shrink-0' parentClassName='h-fit my-auto' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="basket-card.tsx" />

                <div className='flex w-full flex-col gap-1'>
                    <div className='flex w-full flex-col-reverse gap-1 lg:flex-row lg:items-center lg:justify-between'>
                        <span className='text-caption-12 text-text-darkGray lg:text-body-14'>{brand}</span>

                        {changeType === CartItemChangeType.QtyDecrease && <span className='text-caption-12 text-alert-warning-dark'>
                                موجودی این کالا کاهش پیدا کرده است.
                            </span>}
                    </div>

                    <h3 className='line-clamp-2 text-caption-12 text-text-black lg:text-body-14'>{name}</h3>

                    <BasketCardVariants color={color} weightUnit={weightUnit} weightValue={weightValue} data-sentry-element="BasketCardVariants" data-sentry-source-file="basket-card.tsx" />

                    {shipBySeller && <div className='mt-1 flex items-center gap-1 lg:mt-2'>
                            <IconUser className='h-4 w-4 text-text-darkGray' />
                            <span className='font-regular text-caption-12 text-text-mediumGray lg:text-body-14'>
                                ارسال فروشنده
                            </span>
                        </div>}

                    {isGift && <div className='mt-1 flex items-center gap-2 text-caption-12 font-medium lg:mt-2 lg:text-body-14'>
                            <span className='font-medium text-text-mediumGray'>تعداد: </span>
                            <span className='lg:font-medium'>{initialCount}</span>
                        </div>}
                </div>
            </div>
            {!isGift && <div className='flex w-full items-center justify-between'>
                    {changeType === CartItemChangeType.OutOfStock ? <span className='mr-auto px-8 py-2.5 text-caption-12 font-medium text-primary-main lg:px-5 lg:py-3 lg:text-body-14'>
                            ناموجود
                        </span> : <>
                            <AddToCartCounter atpId={atpId} maxLimited={maxLimited} initialCount={initialCount} type={CartActionPlacement.cart} />
                            <Pricing {...pricingProps} className='mr-auto' />
                        </>}
                </div>}
            {isPromotionExcluded && <div className='ml-0 mr-auto flex items-center justify-center rounded bg-alert-warning-light p-1'>
                    <span className='font-regular leading-1 text-caption-10 text-alert-warning-dark lg:text-caption-12'>
                        این کالا شامل کد تخفیف نمی‌شود
                    </span>
                </div>}
        </AppNextLink>;
};